/**
 * RegistroCompra GraphQL Mutations
 * Mutations reales del backend de FinancialService
 */

/**
 * Mutation para crear un nuevo Registro de Compra
 * [Refactorizado]
 */
export const CREATE_REGISTRO_COMPRA = `
  mutation createRegistroCompra($model: inputRegistroCompra!) {
    createRegistroCompra(model: $model) {
      id
      listaOS {
        numberOS
      }
    }
  }
`;

/**
 * Mutation para actualizar un Registro de Compra
 * [Refactorizado]
 */
export const UPDATE_REGISTRO_COMPRA = `
  mutation UpdateRegistroCompra($id: String!, $changes: updateRegistroCompraInput!) {
    updateRegistroCompra(id: $id, changes: $changes) {
      id
      updatedAt
    }
  }
`;

/**
 * Mutation para eliminar un Registro de Compra
 * [Refactorizado]
 */
export const DELETE_REGISTRO_COMPRA = `
  mutation deleteRegistroCompra($id: String!) {
    deleteRegistroCompra(id: $id)
  }
`;

/**
 * Mutation para actualizar el estado hasDocument de un Registro de Compra
 * [Refactorizado]
 */
export const UPDATE_REGISTRO_COMPRA_HAS_DOCUMENT = `
  mutation updateRegistroCompraHasDocument($id: String!, $hasDocument: Boolean!) {
    updateRegistroCompraHasDocument(id: $id, hasDocument: $hasDocument)
  }
`;
